export const API_PATH = {
  auth: {
    login: '/api/auth/login',
    logout: '/api/auth/logout',
    refreshToken: '/api/auth/refresh-token',
    validateCaptcha: '/api/auth/validate-captcha',
    register: '/api/auth/register',
    resendEmailVerification: '/api/auth/re-send-verification-account',
    verification: '/api/auth/verification',
    registerVendor: '/api/auth/register/vendor-account',
    userProfile: '/api/user/profile',
    changePassword: '/api/auth/change-password',
    forgotPassword: '/api/auth/forgot-password',
    forgotPasswordChanged: '/api/auth/forgot-password/change-password',
    forgotPasswordValidate: '/api/auth/forgot-password/validate',
    subscriptionStatus: '/api/auth/subscription-status',
    initAuthorization: '/api/auth/init-authorization',
  },
  mobi: {
    order: '/api/mobi/order',
    orderDriverLog: '/api/mobi/order/driver/log',
    orders: '/api/mobi/orders',
    cancelOrders: '/api/mobi/orders/:id/cancel',
    cancelOrdersAssignment: '/api/mobi/orders/:id/cancel-assignment',
    orderDeliveryNotes: '/api/mobi/orders/:id/delivery-notes',
    addSalesOrder: '/api/mobi/orders/add-sales-order',
    fromSalesOrder: '/api/mobi/orders/from-sales-order',
    orderTravelExpenseCategoriesByOrganization:
      '/api/mobi/order/travel-expense-categories-by-organization',
    orderTravelExpenseCategories: '/api/mobi/order/travel-expense-categories',
    orderBulk: '/api/mobi/order/bulk',
  },
  optima: {
    deleteOrderEntries: '/api/optima/delete-order-entries',
    archivePlans: '/api/optima/archive-plans',
    validateOrderEntries: '/api/optima/validate-order-entries',
    createOrderEntries: '/api/optima/create-order-entries',
    updateOrderEntries: '/api/optima/update-order-entries',
    preGenerateOrderPlan: '/api/optima/pre-generate-order-plan',
    generateOrderPlan: '/api/optima/generate-order-plan',
    confirmUnloadOrderEntries: '/api/optima/confirm-unload-order-entries',
    addPlannedOrderEntries: '/api/optima/add-planned-order-entries',
    renamePlan: '/api/optima/rename-plan',
    orderPlanPercentage: '/api/optima/order-plan-percentage',
    orderEntries: '/api/optima/order-entries',
    orderPlan: '/api/optima/order-plan',
    orderPlans: '/api/optima/order-plans',
    generateOrderEntriesTemplate: '/api/optima/generate-order-entries-template',
    generateDeliveryOrder: '/api/optima/generate-delivery-order',
    generateDeliveryOrderValidate:
      '/api/optima/generate-delivery-order/validate',
    editOrderPlanResult: '/api/optima/edit-order-plan-result',
    reroutePointClusters: '/api/optima/reroute-point-clusters',
    editClusterFleet: '/api/optima/edit-cluster-fleet',
    validateEditClusterFleet: '/api/optima/validate-edit-cluster-fleet',
    searchOrderPlanResult: '/api/optima/search-order-plan-result',
    splitClusterPreview: '/api/optima/split-cluster-preview',
    splitCluster: '/api/optima/split-cluster',
    addClusterPreview: '/api/optima/add-cluster-preview',
    addCluster: '/api/optima/add-cluster',
    regenerateOrderPlan: '/api/optima/regenerate-order-plan',
    calculateRouteCluster: '/api/optima/calculate-route-cluster',
    editCalculateRouteCluster: '/api/optima/edit-calculate-route-cluster',
    routingRoutes: '/api/optima/routing/routes',
    updateDetailPlan: '/api/optima/update-detail-plan',
    calculateDurationTimePlan: '/api/optima/calculate-duration-time-plan',
    removeSoLineItems: '/api/optima/remove-so-line-items',
    salesOrder: '/api/optima/sales-order',
    salesOrderBulk: '/api/optima/sales-order/bulk',
    salesOrderFilterCustomFields:
      '/api/optima/sales-order/filter-custom-fields',
    salesOrderStatusList: '/api/optima/sales-order/status-list',
    salesOrderLineItems: '/api/optima/sales-order/line-items',
    salesOrderLineItemNames: '/api/optima/sales-order/line-item-names',
    salesOrderFilterBatch: '/api/optima/sales-order/filter-batch',
    salesOrderDelete: '/api/optima/sales-order/delete',
    salesOrderCancel: '/api/optima/sales-order/:id/cancel',
    salesOrderBulkUpdateStatus: '/api/optima/sales-order/bulk-update-status',
    salesOrderBulkUpdateFields: '/api/optima/sales-order/bulk-update-fields',
    salesOrderStatusAccessKeysTransitions:
      '/api/optima/sales-order/status-access-keys-transitions',
    salesOrderBatches: '/api/optima/sales-order/batches',
    salesOrderBatchCancel: '/api/optima/sales-order/batch/cancel',
    salesOrderBatchDelete: '/api/optima/sales-order/batch/delete',
    salesOrderBatchResume: '/api/optima/sales-order/batch/resume',
    salesOrderBatchPercentage: '/api/optima/sales-order/batch/percentage',
    salesOrderValidate: '/api/optima/sales-order/validate',
    salesOrderUpdateLocation: '/api/optima/sales-order/update-location',
    updateLocationSo: '/api/optima/update-location-so',
    generateOrderPlanReport: '/api/optima/generate-order-plan-report',
    generateEditSalesOrderTemplate:
      '/api/optima/generate-edit-sales-order-template',
    bulkEditSalesOrder: '/api/optima/bulk-edit-sales-order',
    recalculateDurationClusters:
      '/api/optima/recalculate-total-duration-clusters',
    fleetLoadsOrderPlan: '/api/optima/fleet-loads-order-plan',
    clusterTags: '/api/optima/cluster/tags',
    clusterDriver: '/api/optima/cluster/driver',
    clusterLoadDate: '/api/optima/cluster/load-date',
    planFilterClusterTags: '/api/optima/plan/filter-cluster-tags',
    planActivityHistories: '/api/optima/plan/activity-histories',
    acceptSuggestion: '/api/optima/accept-suggestion',
    orderPlanRules: '/api/optima/order-plan-rules',
    searchReviewOrders: '/api/optima/search-review-orders',
    reviewMergeIdenticalLocations:
      '/api/optima/review/merge-identical-locations',
    reviewCancelMergeIdenticalLocations:
      '/api/optima/review/cancel-merge-identical-locations',
  },
  fleet: {
    brands: 'api/fleet/brands',
    vehicle: 'api/fleet/vehicle',
    vehicleType: 'api/fleet/vehicle/type',
    vehicleOwnership: 'api/fleet/vehicle/ownership',
    vehicleStatus: 'api/fleet/vehicle/status',
    vehicleFinancialSummary: 'api/fleet/vehicle/:id/financial/summaries',
    vehicleProjects: 'api/fleet/vehicle/:id/projects',
    vehicleReportFinances: 'api/fleet/vehicle/:id/report/finances',
    v2Vehicle: 'api/fleet/v2/vehicle',
    generateFleetTemplate: 'api/fleet/generate-fleet-template',
    generateFleetVendorTemplate: 'api/fleet/generate-fleet-vendor-template',
    generateDriverTemplate: 'api/fleet/generate-driver-template',
    disconnectGps: 'api/fleet/:vehicleId/gps',
    gpsTypes: 'api/fleet/gps/types',
    connectGps: 'api/fleet/:vehicleId/gps',
    drivers: 'api/fleet/drivers',
    driversStatus: 'api/fleet/drivers/:driverId/status',
  },
  vendor: {
    detail: '/api/vendor/:id',
    list: '/api/vendor/list',
    validateUpload: '/api/vendor/validate-upload',
    add: '/api/vendor/add',
    delete: '/api/vendor/delete',
    edit: '/api/vendor/edit',
    invitation: '/api/vendor/invitation',
    priceList: '/api/vendor/price-list',
    generatePriceListTemplate: '/api/vendor/generate-price-list-template',
    validatePriceList: '/api/vendor/validate-price-list',
    createPriceList: '/api/vendor/create-price-list',
  },
  user: {
    organization: '/api/user/organization',
    setting: '/api/user/setting',
    list: '/api/user/list',
  },
  shared: {
    appVersion: '/api/shared/app-version',
    nominatimReverseToken: '/api/shared/nominatim/reverse/token',
    nominatimReverse: '/api/shared/nominatim/reverse',
    nominatimDriving: '/api/shared/nominatim/driving',
    country: '/api/shared/country',
    cities: '/api/shared/cities',
    cityDistrict: '/api/shared/city-district',
    districts: '/api/shared/districts',
    location: '/api/shared/location',
    deleteLocation: '/api/shared/delete-location',
    validateLocationName: '/api/shared/validate-location-name',
    preInsertLocations: '/api/shared/pre-insert-locations',
    locations: '/api/shared/locations',
    googleSearch: '/api/shared/google/search',
    googlePlacesDetails: '/api/shared/google/places/details',
    locationSearch: '/api/shared/location/search',
    config: '/api/shared/config',
    orgConfig: '/api/shared/org-config',
    zoneGroupList: '/api/shared/zone/group/list',
    templateConverter: '/api/shared/template-converter',
    getFleetCluster: '/api/shared/get-fleet-cluster',
    getCargoTypes: '/api/shared/get-cargo-types',
    cargoTypes: '/api/shared/cargo-types',
    deleteCargoTypes: '/api/shared/delete-cargo-types',
    uoms: '/api/shared/uoms',
    banks: '/api/shared/banks',
    dashboard: '/api/shared/dashboard',
    sku: '/api/shared/sku',
    skuGenerateTemplate: '/api/shared/generate-sku-template',
    skuValidate: '/api/shared/sku/validate',
    skuAdd: '/api/shared/sku/add',
    skuDelete: '/api/shared/delete-sku',
    invoiceVendorCustomer: '/api/shared/invoice-vendor-customer',
    getFleetZone: '/api/shared/get-fleet-zone',
    zones: '/api/shared/zones',
    zone: '/api/shared/zone',
    deleteZones: '/api/shared/delete-zones',
    zoneFleetPriority: '/api/shared/zone/fleet-priority',
    zoneTemplates: '/api/shared/zone/templates',
    zoneTemplate: '/api/shared/zone/template',
    zoneGroup: '/api/shared/zone/group',
    zoneGroupDeletes: '/api/shared/zone/group/deletes',
    zoneGroupClone: '/api/shared/zone/group/clone',
  },
  storage: {
    fileNoAuth: 'api/storage/file/no-auth',
    fileNoSignedUrl: '/api/storage/file/no-signed-url',
  },
  shippers: '/api/shippers',
  invoice: {
    detail: '/api/invoice/:id',
  },
  quotation: {
    list: '/api/quotation/list',
  },
};
